import Action from '../animationIcon/action/action';
import Download from '../animationIcon/download/download';
import MobileShot from '../animationIcon/mobileShot/mobileShot';
import Submit from '../animationIcon/submit/submit';
import Upload from '../animationIcon/upload/upload';
import Main from '../layout/main/main';
import styles from './enter.module.css';
const Enter = () => {
  return (
    <Main h="How to Enter" activeIndex="2" className="sm5-active-section">
      <div className={styles.contentGrid}>
        <div className={`${styles.enterCard} sm5-active-fade-in-element`}>
          <MobileShot />
          <h3>Step 1</h3>
          <div>
            Choose a category and shoot the film using smartphones. (The film
            can include some drone or action cam footage if needed). The film
            must be longer than 30 seconds and under 4 minutes.
            <div className="sm5-active-note">
              *You don't need to own a ZHIYUN gimbal to join, feel free to use
              any equipment you prefer. Global users are welcome to enter.
            </div>
          </div>
        </div>

        {/* <div className={`${styles.enterCard} sm5-active-fade-in-element`}>
          <Action />
          <h3>Step 2</h3>
          <div>
            Make a behind-the-scenes film to show us how you made your amazing
            short film, up to 2 minutes.
          </div>
        </div> */}

        <div className={`${styles.enterCard} sm5-active-fade-in-element`}>
          <Download />
          <h3>Step 2</h3>
          <div>
            <a
              href="https://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/Starter-kit-Artlist.zip"
              download
            >
              Download our starter kit{' '}
            </a>
            provided by Artlist, or open a free trial account on{' '}
            <a href="https://artlist.io/?utm_source=zhiyun&utm_medium=al_social&utm_campaign=zhiyun">
              Artlist
            </a>{' '}
            to use their music to edit your film!
          </div>
        </div>

        <div className={`${styles.enterCard} sm5-active-fade-in-element`}>
          <Upload />
          <h3>Step 3</h3>
          <div>
            Upload the film on YouTube or Instagram, hashtag{' '}
            <span className={styles.enterSpan}>#zhiyunmobilefilmchallenge</span>
            , and include the category that you choose in the title or caption,
            e.g. The Horror film (name of the film) | Narrative{' '}
            <span className={styles.enterSpan}>#zhiyunmobilefilmchallenge</span>{' '}
            (Must set to public).
          </div>
        </div>

        <div className={`${styles.enterCard} sm5-active-fade-in-element`}>
          <Submit />
          <h3>Step 4</h3>
          <div>
            Submit the film with the link to your YouTube or Instagram post, and
            the original file download link to{' '}
            <span className={styles.enterSpan}>official@zhiyun-tech.com</span>{' '}
            when you finished.
          </div>

          <div className="sm5-active-note">
            *Bonus point: We have made a special prize for entries with BTS
            uploaded: Posting behind-the-scenes on YouTube or Instagram with
            #zhiyunmobilefilmchallenge will get a chance to win 500 USD in cash.
          </div>
        </div>
        <div className={`${styles.enterCard} sm5-active-fade-in-element`}>
          <h3>The Requirements</h3>
          <ul className={styles.requirementsGrid}>
            <li>
              The film must be shot mostly on phones, 80% or more, with a
              resolution equal to 1080p or higher.
            </li>
            <li>
              The film must include the music from Artlist. (not entirely, but
              must include a part of), if you are already an Artlist subscriber,
              feel free to use any song from Artlist.
            </li>
            <li>
              Must give credit to the name of the song used in the film, either
              in the text of the post, description box of Youtube, in the film,
              or in the email.
            </li>
            <li>
              The film must be longer than 30 seconds, and under 4 minutes.
            </li>
            <li>The film must be uploaded and submitted before March 21th.</li>
            <li>Must only submit one film per category.</li>
          </ul>
        </div>
      </div>
    </Main>
  );
};

export default Enter;
